import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FlexboxModule,
  GridModule,
  MediaCardModule,
  PaddingModule,
  SpacingModule,
  TabsModule as EdsTabsModule,
  ThumbnailModule,
  TitleModule,
} from '@frk/eds-components';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import { PipesModule } from '@shared/pipes/pipes.module';
import { TranslateModule } from '@shared/translate/translate.module';
import { ThumbnailsSectionComponent } from './thumbnails-section/thumbnails-section.component';
import { MediaCardsSectionComponent } from './media-cards-section/media-cards-section.component';
import { MediaCardsIndexComponent } from './media-cards-index/media-cards-index.component';
import { MediaCardGroupComponent } from './media-card-group.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    ThumbnailsSectionComponent,
    MediaCardsSectionComponent,
    MediaCardsIndexComponent,
    MediaCardGroupComponent,
  ],
  imports: [
    CommonModule,
    EdsTabsModule,
    MediaCardModule,
    SpacingModule,
    GridModule,
    BrSdkModule,
    FlexboxModule,
    PaddingModule,
    ThumbnailModule,
    TitleModule,
    PipesModule,
    TranslateModule,
    SharedModule,
  ],
  exports: [
    ThumbnailsSectionComponent,
    MediaCardsSectionComponent,
    MediaCardsIndexComponent,
    MediaCardGroupComponent,
  ],
})
export class MediaCardGroupModule {}
